import {map, of} from 'rxjs';
import {useMemo} from 'react';

import type {Conversation} from '@stripe-internal/conversations-client';
import {useSyncConversationObservable} from '@stripe-internal/conversations-ui';

import {hasUserSentMessage} from '../../core/lib/util/conversationUtils';

export function useHasUserMessage(conversation: Conversation | null): boolean {
  const observableAdapter = useMemo(() => {
    const get = () => (conversation ? hasUserSentMessage(conversation) : false);
    const observable = conversation
      ? conversation.log.observable().pipe(map(get))
      : of(false);

    return {
      observable: () => observable,
      get,
    };
  }, [conversation]);

  return useSyncConversationObservable(observableAdapter);
}
